import Autocomplete from '@mui/material/Autocomplete';
import { FormHelperText } from '@mui/material';
import { TextField } from '@mui/material';
import { useFetch } from '../../../../hooks/useFecth';

export default function SelectBrandLomadee({ value, name, onChange, placeholder, label }) {
    const { data, mutate, error, isFetching } = useFetch(`brokers/lomadee/brands`, {
        params: { limit: 100 },
    });

    const options =
        data?.brands?.map(item => ({
            id: item.id,
            label: item.name,
            ...item,
        })).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) || [];

    const selected = options?.find(item => value === item.id) || null;


    return (
        <>
            <Autocomplete
                fullWidth
                clearText='Remover'
                placeholder={placeholder}
                getOptionLabel={option => option.label}
                //isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionKey={e => e.id}
                options={options}
                value={selected}
                name={name}
                loading={isFetching}
                onChange={(e, newValue) => onChange(newValue)}
                renderInput={params => <TextField {...params} label={placeholder || label} />}
            />
            {!!error?.message && <FormHelperText>{error?.message}</FormHelperText>}
        </>
    );
}

